import { createAction, props } from '@ngrx/store';
import {
  FoodGuideItem,
  FoodGuideListResponse,
  FoodGuideAuditResponse,
} from '../model/food-guide.model';

/******** CLEAR STATE ***********/
const CLEAR_STATE = '[food guide] clear state';
export const ClearState = createAction(CLEAR_STATE);

/******** FETCH FOOD GUIDE LIST ***********/
const FETCH_FOOD_GUIDE_LIST_REQUEST = '[food guide] fetch list request';
export const FetchFoodGuideListRequest = createAction(FETCH_FOOD_GUIDE_LIST_REQUEST, props<{
  payload: any
}>());

const FETCH_FOOD_GUIDE_LIST_SUCCESS = '[food guide] fetch list success';
export const FetchFoodGuideListSuccess = createAction(FETCH_FOOD_GUIDE_LIST_SUCCESS, props<{
  data: FoodGuideListResponse,
  message: string
}>());

const FETCH_FOOD_GUIDE_LIST_FAILURE = '[food guide] fetch list failure';
export const FetchFoodGuideListFailure = createAction(FETCH_FOOD_GUIDE_LIST_FAILURE);

/******** FETCH FOOD GUIDE ITEM ***********/
const FETCH_FOOD_GUIDE_ITEM_REQUEST = '[food guide] fetch item request';
export const FetchFoodGuideItemRequest = createAction(FETCH_FOOD_GUIDE_ITEM_REQUEST, props<{
  payload: { id: number }
}>());

const FETCH_FOOD_GUIDE_ITEM_SUCCESS = '[food guide] fetch item success';
export const FetchFoodGuideItemSuccess = createAction(FETCH_FOOD_GUIDE_ITEM_SUCCESS, props<{
  data: FoodGuideItem,
  message: string
}>());

const FETCH_FOOD_GUIDE_ITEM_FAILURE = '[food guide] fetch item failure';
export const FetchFoodGuideItemFailure = createAction(FETCH_FOOD_GUIDE_ITEM_FAILURE);

/******** CREATE FOOD GUIDE ITEM ***********/
const CREATE_FOOD_GUIDE_ITEM_REQUEST = '[food guide] create item request';
export const CreateFoodGuideItemRequest = createAction(CREATE_FOOD_GUIDE_ITEM_REQUEST, props<{
  payload: any
}>());

const CREATE_FOOD_GUIDE_ITEM_SUCCESS = '[food guide] create item success';
export const CreateFoodGuideItemSuccess = createAction(CREATE_FOOD_GUIDE_ITEM_SUCCESS, props<{
  data: FoodGuideItem,
  message: string
}>());

const CREATE_FOOD_GUIDE_ITEM_FAILURE = '[food guide] create item failure';
export const CreateFoodGuideItemFailure = createAction(CREATE_FOOD_GUIDE_ITEM_FAILURE);

/******** UPDATE FOOD GUIDE ITEM ***********/
const UPDATE_FOOD_GUIDE_ITEM_REQUEST = '[food guide] update item request';
export const UpdateFoodGuideItemRequest = createAction(UPDATE_FOOD_GUIDE_ITEM_REQUEST, props<{
  payload: any
}>());

const UPDATE_FOOD_GUIDE_ITEM_SUCCESS = '[food guide] update item success';
export const UpdateFoodGuideItemSuccess = createAction(UPDATE_FOOD_GUIDE_ITEM_SUCCESS, props<{
  data: FoodGuideItem,
  message: string
}>());

const UPDATE_FOOD_GUIDE_ITEM_FAILURE = '[food guide] update item failure';
export const UpdateFoodGuideItemFailure = createAction(UPDATE_FOOD_GUIDE_ITEM_FAILURE);

/******** RETIRE FOOD GUIDE ITEM ***********/
const RETIRE_FOOD_GUIDE_ITEM_REQUEST = '[food guide] retire item request';
export const RetireFoodGuideItemRequest = createAction(RETIRE_FOOD_GUIDE_ITEM_REQUEST, props<{
  payload: { id: number }
}>());

const RETIRE_FOOD_GUIDE_ITEM_SUCCESS = '[food guide] retire item success';
export const RetireFoodGuideItemSuccess = createAction(RETIRE_FOOD_GUIDE_ITEM_SUCCESS, props<{
  message: string
}>());

const RETIRE_FOOD_GUIDE_ITEM_FAILURE = '[food guide] retire item failure';
export const RetireFoodGuideItemFailure = createAction(RETIRE_FOOD_GUIDE_ITEM_FAILURE);

/******** UNRETIRE FOOD GUIDE ITEM ***********/
const UNRETIRE_FOOD_GUIDE_ITEM_REQUEST = '[food guide] unretire item request';
export const UnretireFoodGuideItemRequest = createAction(UNRETIRE_FOOD_GUIDE_ITEM_REQUEST, props<{
  payload: { id: number }
}>());

const UNRETIRE_FOOD_GUIDE_ITEM_SUCCESS = '[food guide] unretire item success';
export const UnretireFoodGuideItemSuccess = createAction(UNRETIRE_FOOD_GUIDE_ITEM_SUCCESS, props<{
  message: string
}>());

const UNRETIRE_FOOD_GUIDE_ITEM_FAILURE = '[food guide] unretire item failure';
export const UnretireFoodGuideItemFailure = createAction(UNRETIRE_FOOD_GUIDE_ITEM_FAILURE);

/******** FETCH AUDIT HISTORY ***********/
const FETCH_FOOD_GUIDE_HISTORY_REQUEST = '[food guide] fetch history request';
export const FetchFoodGuideHistoryRequest = createAction(FETCH_FOOD_GUIDE_HISTORY_REQUEST, props<{
  payload: { id: number, pageNumber?: number, limit?: number }
}>());

const FETCH_FOOD_GUIDE_HISTORY_SUCCESS = '[food guide] fetch history success';
export const FetchFoodGuideHistorySuccess = createAction(FETCH_FOOD_GUIDE_HISTORY_SUCCESS, props<{
  data: FoodGuideAuditResponse,
  message: string
}>());

const FETCH_FOOD_GUIDE_HISTORY_FAILURE = '[food guide] fetch history failure';
export const FetchFoodGuideHistoryFailure = createAction(FETCH_FOOD_GUIDE_HISTORY_FAILURE);

/******** FETCH FOOD CATEGORIES ***********/
const FETCH_FOOD_CATEGORIES_REQUEST = '[food guide] fetch food categories request';
export const FetchFoodCategoriesRequest = createAction(FETCH_FOOD_CATEGORIES_REQUEST);

const FETCH_FOOD_CATEGORIES_SUCCESS = '[food guide] fetch food categories success';
export const FetchFoodCategoriesSuccess = createAction(FETCH_FOOD_CATEGORIES_SUCCESS, props<{
  data: { list: { key: number, value: string }[] }
}>());

const FETCH_FOOD_CATEGORIES_FAILURE = '[food guide] fetch food categories failure';
export const FetchFoodCategoriesFailure = createAction(FETCH_FOOD_CATEGORIES_FAILURE);
